import React, { useState } from 'react';
import { Card, Button, Space, Tooltip } from 'antd';
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import { useTheme } from 'contexts/theme';

import styles from './container.module.sass';

export default function Container({
  title,
  children,
  height,
  enableFullScreen,
  extra
}: {
  title?: string;
  children: React.ReactNode;
  height?: number;
  enableFullScreen?: boolean;
  extra?: React.ReactNode[];
}) {
  const { dark } = useTheme();
  const [fullScreen, setFullScreen] = useState(false);
  function toggleFullScreen() {
    setFullScreen(!fullScreen);
  }
  function getContainerClass() {
    if (fullScreen) {
      return dark ? styles['full-screen-dark'] : styles['full-screen-light'];
    }
    return '';
  }

  function renderExtra() {
    let extraArray = extra || [];
    if (enableFullScreen) {
      extraArray = [
        ...(extra ? extra : []),
        <Tooltip title={fullScreen ? 'Minimize' : 'Maximize'}>
          <Button
            key="fullscreen"
            type="primary"
            icon={
              fullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />
            }
            onClick={toggleFullScreen}
          />
        </Tooltip>
      ];
    }
    return extraArray;
  }

  return (
    <div className={getContainerClass()}>
      <Card
        style={{
          height: `${height}px`,
          overflowY: height ? 'scroll' : 'inherit'
        }}
        title={title}
        className={dark ? styles['container-dark'] : styles.container}
        bordered={false}
        extra={<Space>{renderExtra()}</Space>}
      >
        {children}
      </Card>
    </div>
  );
}
